<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-9 col-md-7">
                    <ol class="breadcrumb">
                        <li><router-link :to="{name:'calendar'}">Home</router-link></li>
                        <li><router-link :to="{name:'content'}">{{$t('views.content.title')}}</router-link></li>
                        <li><router-link :to="{name:'videos'}">{{$t('views.videos.title')}}</router-link></li>
                        <li class="active">{{video.title}}</li>
                    </ol>
                </div>
                <div class="col-xs-3 col-md-5 text-right">
                    <button class="btn btn-default" @click="$router.push({name:'videos'})">
                        <i class="las la-undo"></i>
                        <span class="button-text">{{$t('navigation.back_to_videos')}}</span>
                    </button>
                </div>
            </div>
            <hr>
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-7">
                    <h1 class="h2 margin-0">{{video.title}}</h1>
                </div>
                <div class="col-xs-12 col-md-5 text-right">

                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <div class="panel panel-default margin-bottom-40">
                        <div class="panel-heading">{{$t('views.video_detail.settings')}}</div>
                        <div class="panel-body">
                            <VideoForm :uploadingVideo="uploadingVideo" :video-prop="video" @change="onChangeVideo" :hide-visibility-video="video.video_id == null"></VideoForm>
                        </div>
                        <div class="panel-footer"><a id="save-reservation-btn" href="" class="btn btn-default btn-lg btn-block margin-bottom-10" @click.stop.prevent="saveVideoClick"><i class="las la-check"></i>{{$t('common.save_change')}}</a><a href="" class="text-danger margin-bottom-20" @click.prevent.stop="showDeleteVideoModal">{{$t('views.video_detail.archive')}}</a></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6" v-if="video.state === VIDEO_STATE.READY">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" :src="'https://player.vimeo.com/video/' + video.video_id" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                    </div>
                </div>
                <div v-else-if="video.state === VIDEO_STATE.STATE_TRANSCODING" class="col-xs-12 col-sm-6">
                    <div
                            class="alert alert-success"
                            role="alert"
                    >
                        {{ $t('views.video_detail.upload_completed') }}
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6" v-else>
                    <input type="file" @change="previewFiles" class="margin-bottom-20">

                    <div class="progress" v-show="uploadingVideo">
                        <div class="progress-bar" role="progressbar" :aria-valuenow="uploadingProgress"
                             aria-valuemin="0" aria-valuemax="100" :style="{ width: uploadingProgress + '%'}">
                            {{uploadingProgress}}%
                        </div>
                    </div>

                    <button class="btn btn-primary text-center"  :disabled="!fileToUpload || uploadingVideo" @click="uploadFile()">
                        Upload video
                    </button>
                </div>
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
        <GenericChooseModal
                :message="$t('views.video_detail.modal_archive_message')"
                :title="$t('views.video_detail.archive')"
                :visible="archiveVideoModalVisible"
                :positive-button-text="$t('views.video_detail.modal_archive_positive')"
                :negative-button-text="$t('views.video_detail.modal_archive_negative')"
                danger
                @positive-click-generic-modal="positiveButtonDeleteVideoModalClick"
                @negative-click-generic-modal="negativeButtonDeleteVideoModalClick"
                @close-generic-modal="negativeButtonDeleteVideoModalClick"
        />

        <GenericChooseModal
                :title="$t('views.video_detail.modal_exit_title')"
                :message="$t('views.video_detail.modal_exit_message')"
                :visible="exitUploadingVideoModalVisible"
                :positive-button-text="$t('common.continue')"
                primary
                @positive-click-generic-modal="positiveButtonExitUploadVideo"
                @negative-click-generic-modal="exitUploadingVideoModalVisible=false"
                @close-generic-modal="exitUploadingVideoModalVisible=false"
                :hideNegativeButton="true"
        />
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {Utils} from "../common/utils";
    import i18n from "../i18n";
    import {completeUploadVideo, archiveVideo, getVideoDetail, updateVideo, uploadVideo} from "../api";
    import GenericChooseModal from "../components/modal/GenericChooseModal";
    import VideoForm from "../components/video/VideoForm";
    import * as tus from "tus-js-client";
    import {VIDEO_STATE} from "../common/constants";

    export default {
        title: i18n.t('views.video_detail.title'),
        name: "VideoDetail",
        components: {VideoForm, ContainerWithMenu, SpinnerLoader, GenericChooseModal},
        data: function () {
            return {
                loading: false,
                video: {},
                archiveVideoModalVisible: false,
                exitUploadingVideoModalVisible: false,
                uploadingVideo: false,
                exitToRoute: null,
                fileToUpload: null,
                VIDEO_STATE: VIDEO_STATE,
                uploadingProgress: 0
            }
        },
        async mounted() {
            this.getVideoData()
        },

        created() {
            window.addEventListener('beforeunload', this.beforeWindowUnload)
        },

        beforeDestroy() {
            window.removeEventListener('beforeunload', this.beforeWindowUnload)
        },
        beforeRouteLeave (to, from , next) {
            if (this.uploadingVideo) {
                this.exitUploadingVideoModalVisible = true;
                this.exitToRoute = to;
            } else {
                next()
            }

        },
        methods: {
            getStringStateVideo(state) {
                return Utils.getStringStateVideo(state)
            },
            confirmLeave() {
                return window.confirm('Do you really want to leave? you have unsaved changes!')
            },
            confirmStayUploading() {
                return this.uploadingVideo && !this.confirmLeave()
            },

            beforeWindowUnload(e) {
                if (this.confirmStayUploading()) {
                    // Cancel the event
                    e.preventDefault();
                    // Chrome requires returnValue to be set
                    e.returnValue = ''
                }
            },
            previewFiles(event) {
                this.fileToUpload = event.target.files[0];
            },
            positiveButtonExitUploadVideo() {
                let route = this.$router.resolve(this.exitToRoute);
                this.exitUploadingVideoModalVisible = false;
                window.open(route.href, '_blank');
            },
            async getVideoData() {
                this.loading = true;
                try {
                    this.video = await getVideoDetail(this.$route.params.video_id);
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            showDeleteVideoModal() {
                this.archiveVideoModalVisible = true
            },
            async positiveButtonDeleteVideoModalClick() {
                this.loading = true;
                try {
                    await archiveVideo(this.video.id);
                    this.loading = false;
                    this.archiveVideoModalVisible = false;
                    this.$nextTick(() => {
                        this.$router.push({ name: 'videos', params: { successMessage: i18n.t('views.video_detail.archive_success') }});
                    });
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            negativeButtonDeleteVideoModalClick() {
                this.archiveVideoModalVisible = false
            },
            async saveVideoClick() {
                this.loading = true;
                await updateVideo(
                    this.$route.params.video_id,
                    this.video.title,
                    this.video.description,
                    this.video.visibility,
                    this.video.language);
                try {

                    this.loading = false;
                    this.$route.params.successMessage = i18n.t('views.video_detail.update_success');
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            onChangeVideo(video) {
                this.video = video;
            },
            getLongDateFromISO(date){
                return Utils.getLongDateFromISO(date)
            },
            async uploadFile() {
                let self = this;
                this.loading = true;
                try {
                    let response = await uploadVideo(this.video.id, this.fileToUpload.size);
                    this.uploadingVideo = true;

                    let upload = new tus.Upload(this.fileToUpload, {
                        uploadUrl: response.upload.upload_link,
                        retryDelays: [0, 3000, 5000, 10000, 20000],
                        chunkSize: 25000000,
                        onError: function(error) {
                            console.log("Failed because: " + error)
                        },
                        onProgress: function(bytesUploaded, bytesTotal) {
                            self.uploadingProgress = (bytesUploaded / bytesTotal * 100).toFixed(2);
                        },
                        onSuccess: async function() {
                            this.loading = true;
                            try {
                                this.video = await completeUploadVideo(self.$route.params.video_id);
                                this.loading = false;
                            } catch (e) {
                                this.loading = false;
                                console.log(e)
                            }
                            self.uploadingVideo = false;
                            self.video.state = VIDEO_STATE.STATE_TRANSCODING;
                        },
                    });

                    // Check if there are any previous uploads to continue.
                    upload.findPreviousUploads().then(function (previousUploads) {
                        // Found previous uploads so we select the first one.
                        if (previousUploads.length) {
                            upload.resumeFromPreviousUpload(previousUploads[0])
                        }

                        // Start the upload
                        upload.start();
                    });

                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }

            }
        }
    }
</script>
